import { useAuthStore } from "@/stores/authStore";

export const useIsLoggedIn = () => {
  const { authStatus } = useAuthStore();
  return authStatus === "LOGGED_IN";
};
